// src/pages/Dashboard/WidgetStatistics.jsx

import React, { useEffect, useState, useRef, useCallback } from "react"; // AÑADIR useRef

import { useParams, useNavigate } from "react-router-dom";

import {

  CircularProgress,

  Typography,

  Container,

  Grid,

  Card,

  Box,

  FormControl,

  Select,

  MenuItem,

  Paper,

  List,

  ListItem,

  ListItemText,

  Chip,

  Dialog,

  DialogContent,

  Button,

  IconButton,

} from "@mui/material";

import AccessibilityIcon from "@mui/icons-material/Accessibility";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

import {

  AreaChart,

  Area,

  XAxis,

  YAxis,

  ResponsiveContainer,

  CartesianGrid,

  Tooltip,

} from "recharts";

import api from "../../services/api";

import { useAuth } from "../../contexts/AuthContext";

import { useTranslation } from "react-i18next";

import PlataformaSelector from "../../components/guias/PlataformaSelector";

import jsPDF from "jspdf";

import html2canvas from "html2canvas";



// Función para transformar datos de herramientas

/* const transformToolsData = (toolsData) => {

  if (!Array.isArray(toolsData)) return [];



  // Agrupar por herramienta y sumar totales

  const toolTotals = {};



  toolsData.forEach(([date, toolName, count]) => {

    if (!toolTotals[toolName]) {

      toolTotals[toolName] = 0;

    }

    toolTotals[toolName] += count;

  });



  // Convertir a array de objetos y ordenar por uso descendente

  return Object.entries(toolTotals)

    .map(([toolName, count]) => ({

      name: translateToolName(toolName),

      value: count,

      originalName: toolName,

    }))

    .sort((a, b) => b.value - a.value);

}; */



// Función para traducir nombres de herramientas al español

/* const translateToolName = (toolName) => {

  const translations = {

    // Herramientas de Color

    light_contrast: "Contraste Claro",

    low_saturation: "Baja Saturación",

    monochrome_color: "Color Monocromático",

    high_contrast: "Alto Contraste",

    high_saturation: "Alta Saturación",

    high_brightness: "Alto Brillo",

    dark_contrast: "Contraste Oscuro",



    // Herramientas de Navegación

    middle_bar: "Barra Central",

    tooltips: "Información Contextual",

    white_cursor: "Cursor Blanco",

    page_structure: "Estructura de Página",

    magnifying_glass: "Lupa",

    screen_reader_normal_speed: "Lector de Pantalla Velocidad Normal",

    keyboard_navigation: "Navegación por Teclado",

    black_cursor: "Cursor Negro",

    smart_navigation: "Navegación Inteligente",



    // Herramientas de Contenido

    links_highlighted: "Enlaces Resaltados",

    text_aligned_left: "Texto Alineado Izquierda",

    dictionary: "Diccionario",

    reading_mode: "Modo Lectura",

    text_aligned_right: "Texto Alineado Derecha",

    block_blinks: "Bloquear Parpadeos",

    legible_typography: "Tipografía Legible",

    sounds_blocked: "Sonidos Bloqueados",

    titles_highlighted: "Títulos Resaltados",

    dyslexic_typography: "Tipografía para Dislexia",

    images_blocked: "Imágenes Bloqueadas",

    text_aligned_justify: "Texto Justificado",

    focus_mode: "Modo Enfoque",

    bionic_reading: "Lectura Biónica",

    text_aligned_center: "Texto Centrado",

  };



  return (

    translations[toolName] ||

    toolName.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())

  );

};



// Función para traducir nombres de perfiles

const translateProfileName = (profile) => {

  const translations = {

    visual_disability: "Discapacidad Visual",

    learning: "Dificultades de Aprendizaje",

    motor_skills_disorder: "Trastorno de Habilidades Motoras",

    blindness: "Ceguera",

    epilepsy: "Epilepsia",

    achromatopsia: "Acromatopsia",

    deuteranopia: "Deuteranopia",

    tdah: "TDAH",

    tritanomaly: "Tritanomalía",

    deuteranomaly: "Deuteranomalía",

    tritanopia: "Tritanopia",

    elderly: "Personas Mayores",

    dyslexia: "Dislexia",

    dislexy: "Dislexia", // Variante del nombre

    protanopia: "Protanopia",

  };



  return (

    translations[profile] || profile.charAt(0).toUpperCase() + profile.slice(1)

  );

}; */



const WidgetStatistics = () => {

  const { domain } = useParams();

  const { t, i18n } = useTranslation();

  const { user } = useAuth();

  const navigate = useNavigate(); // AGREGAR useNavigate



  // Helper functions for translations (usando useCallback para evitar problemas de dependencias)

  const translateProfileName = useCallback((profileKey) => {

    const key = `widgetStatistics.profiles.${profileKey}`;

    const translated = t(key);

    return translated !== key ? translated : profileKey.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());

  }, [t]);



  const translateToolName = useCallback((toolKey) => {

    const key = `widgetStatistics.tools.${toolKey}`;

    const translated = t(key);

    return translated !== key ? translated : toolKey.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());

  }, [t]);



  // Estados existentes

  const [metrics, setMetrics] = useState([]);

  const [loading, setLoading] = useState(true);



  // AGREGAR estado para el modal de guías

  const [guidesModalOpen, setGuidesModalOpen] = useState(false);



  // Nuevos estados

  const [accessProfileData, setAccessProfileData] = useState(null);

  const [accessProfileLoading, setAccessProfileLoading] = useState(true);

  const [dateRange, setDateRange] = useState("30days");

  const [totalAccessProfile, setTotalAccessProfile] = useState(0);



  // Nuevos estados para la funcionalidad de colapsar/expandir

  const [isProfilesExpanded, setIsProfilesExpanded] = useState(true);



  // Estados para las nuevas tarjetas

  const [navigationData, setNavigationData] = useState([]);

  const [colorData, setColorData] = useState([]);

  const [contentData, setContentData] = useState([]);

  const [loadingNavigation, setLoadingNavigation] = useState(true);

  const [loadingColor, setLoadingColor] = useState(true);

  const [loadingContent, setLoadingContent] = useState(true);



  // Estados para colapsar/expandir las nuevas tarjetas

  const [isNavigationExpanded, setIsNavigationExpanded] = useState(true);

  const [isColorExpanded, setIsColorExpanded] = useState(true);

  const [isContentExpanded, setIsContentExpanded] = useState(true);



  // Refs para scroll automático

  const profilesCardRef = useRef(null);

  const navigationCardRef = useRef(null);

  const colorCardRef = useRef(null);

  const contentCardRef = useRef(null);



  // Opciones de rango de fechas

  const dateRangeOptions = [

    { value: "30days", label: t("widgetStatistics.last30Days") },

    { value: "6months", label: t("widgetStatistics.last6Months") },

    { value: "1year", label: t("widgetStatistics.lastYear") },

    { value: "all", label: t("widgetStatistics.historical") },

  ];



  // Función para calcular fechas basadas en el rango seleccionado

  const calculateDateRange = (range) => {

    const now = new Date();

    let fromDate,

      toDate = now;



    switch (range) {

      case "30days":

        fromDate = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);

        break;

      case "6months":

        fromDate = new Date(

          now.getFullYear(),

          now.getMonth() - 6,

          now.getDate()

        );

        break;

      case "1year":

        fromDate = new Date(

          now.getFullYear() - 1,

          now.getMonth(),

          now.getDate()

        );

        break;

      case "all":

        // CAMBIAR: En lugar de null, usar 10 años hacia atrás

        fromDate = new Date(

          now.getFullYear() - 10,

          now.getMonth(),

          now.getDate()

        );

        toDate = now; // Mantener hasta hoy

        break;

      default:

        fromDate = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);

    }



    return {

      from_date: fromDate ? fromDate.toISOString().split("T")[0] : null,

      to_date: toDate ? toDate.toISOString().split("T")[0] : null,

    };

  };



  // Nueva función para obtener access profile



  // Envolver las funciones de fetch con useCallback para evitar recrearlas en cada render

  // ACTUALIZAR el cálculo del total de access profile también

  const fetchMetrics = useCallback(

    async (selectedRange = dateRange) => {

      if (!user || !user.id) {

        setLoading(false);

        return;

      }



      const now = Date.now();

      const lastFetch = localStorage.getItem(

        `metrics-timestamp-${domain}-${selectedRange}`

      );

      const cachedMetrics = localStorage.getItem(

        `metrics-${domain}-${selectedRange}`

      );



      if (lastFetch && now - lastFetch < 60 * 60 * 1000 && cachedMetrics) {

        const parsedMetrics = JSON.parse(cachedMetrics);

        const metricsData = parsedMetrics.data || parsedMetrics;

        setMetrics(metricsData);

        setLoading(false);

        return;

      }



      try {

        setLoading(true);



        const dateParams = calculateDateRange(selectedRange);

        const requestBody = {

          domain: domain,

          user_id: user.id,

          ...dateParams,

        };



        const response = await api.post("/get-metrics", requestBody);



        const metricsData = response.data.data || response.data;

        setMetrics(metricsData);



        // Guardar en caché con el rango de fechas incluido

        localStorage.setItem(

          `metrics-${domain}-${selectedRange}`,

          JSON.stringify(response.data)

        );

        localStorage.setItem(

          `metrics-timestamp-${domain}-${selectedRange}`,

          now.toString()

        );

      } catch (err) {

        if (cachedMetrics) {

          const parsedMetrics = JSON.parse(cachedMetrics);

          const metricsData = parsedMetrics.data || parsedMetrics;

          setMetrics(metricsData);

        }

      } finally {

        setLoading(false);

      }

    },

    [dateRange, domain, user]

  );



  // ACTUALIZAR fetchAccessProfile para usar dailyData también

  const fetchAccessProfile = useCallback(

    async (selectedRange = dateRange) => {

      if (!user || !user.id) {

        setAccessProfileLoading(false);

        return;

      }



      try {

        setAccessProfileLoading(true);



        // Verificar caché

        const now = Date.now();

        const cacheKey = `access-profile-${domain}-${selectedRange}`;

        const timestampKey = `access-profile-timestamp-${domain}-${selectedRange}`;

        const lastFetch = localStorage.getItem(timestampKey);

        const cachedData = localStorage.getItem(cacheKey);



        if (lastFetch && now - lastFetch < 60 * 60 * 1000 && cachedData) {

          const parsedData = JSON.parse(cachedData);

          const responseData = parsedData.data || parsedData;

          setAccessProfileData(responseData);



          // CAMBIAR: Calcular total usando el nuevo formato

          const total = Array.isArray(responseData)

            ? responseData.reduce((sum, item) => {

                // Si es un array [fecha, valor] (formato anterior)

                if (Array.isArray(item) && item.length >= 2) {

                  return sum + (typeof item[1] === "number" ? item[1] : 0);

                }

                // Si es un objeto con dailyData (formato nuevo)

                if (item.dailyData && typeof item.dailyData === "object") {

                  return (

                    sum +

                    Object.values(item.dailyData).reduce(

                      (daySum, dayCount) => daySum + (dayCount || 0),

                      0

                    )

                  );

                }

                // Si es un objeto {value: x}

                return sum + (item.value || 0);

              }, 0)

            : typeof responseData === "number"

            ? responseData

            : 0;

          setTotalAccessProfile(total);



          setAccessProfileLoading(false);

          return;

        }



        const dateParams = calculateDateRange(selectedRange);

        const requestBody = {

          domain: domain,

          user_id: user.id,

          ...dateParams,

        };



        const response = await api.post("/access-profile", requestBody);

        const accessData = response.data.data || response.data;



        setAccessProfileData(accessData);



        // CAMBIAR: Calcular total usando el nuevo formato

        const total = Array.isArray(accessData)

          ? accessData.reduce((sum, item) => {

              // Si es un array [fecha, valor] (formato anterior)

              if (Array.isArray(item) && item.length >= 2) {

                return sum + (typeof item[1] === "number" ? item[1] : 0);

              }

              // Si es un objeto con dailyData (formato nuevo)

              if (item.dailyData && typeof item.dailyData === "object") {

                return (

                  sum +

                  Object.values(item.dailyData).reduce(

                    (daySum, dayCount) => daySum + (dayCount || 0),

                    0

                  )

                );

              }

              // Si es un objeto {value: x}

              return sum + (item.value || 0);

            }, 0)

          : typeof accessData === "number"

          ? accessData

          : 0;

        setTotalAccessProfile(total);



        // Guardar en caché

        localStorage.setItem(cacheKey, JSON.stringify(response.data));

        localStorage.setItem(timestampKey, now.toString());



      } catch (error) {



        // Intentar usar caché expirado

        const cacheKey = `access-profile-${domain}-${selectedRange}`;

        const cachedData = localStorage.getItem(cacheKey);

        if (cachedData) {

          const parsedData = JSON.parse(cachedData);

          setAccessProfileData(parsedData.data || parsedData);

        }

      } finally {

        setAccessProfileLoading(false);

      }

    },

    [dateRange, domain, user]

  );



  // Función para procesar datos de la leyenda de perfiles   ds



  // Funciones para cargar datos - ACTUALIZAR PARA TRANSFORMAR LOS DATOS

  // Funciones para cargar datos - CON CACHÉ IMPLEMENTADA

  // ACTUALIZAR las funciones de fetch para usar datos directos

  const fetchNavigationData = useCallback(

    async (selectedRange = dateRange) => {

      if (!user || !user.id) {

        setLoadingNavigation(false);

        return;

      }



      try {

        setLoadingNavigation(true);



        // Verificar caché

        const now = Date.now();

        const cacheKey = `navigation-data-${domain}-${selectedRange}`;

        const timestampKey = `navigation-timestamp-${domain}-${selectedRange}`;

        const lastFetch = localStorage.getItem(timestampKey);

        const cachedData = localStorage.getItem(cacheKey);



        if (lastFetch && now - lastFetch < 60 * 60 * 1000 && cachedData) {

          const parsedData = JSON.parse(cachedData);

          const responseData = parsedData.data || parsedData;

          const mappedData = Array.isArray(responseData) ? responseData.map(item => ({

            ...item,

            originalName: item.tool || item.originalName || item.name,

            name: translateToolName(item.tool || item.originalName || item.name)

          })) : responseData;

          setNavigationData(mappedData);

          setLoadingNavigation(false);

          return;

        }



        const dateParams = calculateDateRange(selectedRange);

        const requestBody = {

          domain: domain,

          user_id: user.id,

          ...dateParams,

        };



        const response = await api.post("/navigation-tools", requestBody);

        const responseData = response.data?.data || response.data;



        // Mapear datos para incluir originalName si no existe

        const mappedData = Array.isArray(responseData) ? responseData.map(item => ({

          ...item,

          originalName: item.tool || item.originalName || item.name,

          name: translateToolName(item.tool || item.originalName || item.name)

        })) : responseData;



        setNavigationData(mappedData);



        // Guardar en caché

        localStorage.setItem(cacheKey, JSON.stringify(response.data));

        localStorage.setItem(timestampKey, now.toString());



      } catch (error) {



        // Intentar usar caché expirado

        const cacheKey = `navigation-data-${domain}-${selectedRange}`;

        const cachedData = localStorage.getItem(cacheKey);

        if (cachedData) {

          const parsedData = JSON.parse(cachedData);

          const responseData = parsedData.data || parsedData;

          const mappedData = Array.isArray(responseData) ? responseData.map(item => ({

            ...item,

            originalName: item.tool || item.originalName || item.name,

            name: translateToolName(item.tool || item.originalName || item.name)

          })) : responseData;

          setNavigationData(mappedData);

        } else {

          setNavigationData([]);

        }

      } finally {

        setLoadingNavigation(false);

      }

    },

    [dateRange, domain, user, translateToolName]

  );



  // APLICAR LOS MISMOS CAMBIOS a fetchColorData y fetchContentData

  const fetchColorData = useCallback(

    async (selectedRange = dateRange) => {

      if (!user || !user.id) {

        setLoadingColor(false);

        return;

      }



      try {

        setLoadingColor(true);



        // Verificar caché

        const now = Date.now();

        const cacheKey = `color-data-${domain}-${selectedRange}`;

        const timestampKey = `color-timestamp-${domain}-${selectedRange}`;

        const lastFetch = localStorage.getItem(timestampKey);

        const cachedData = localStorage.getItem(cacheKey);



        if (lastFetch && now - lastFetch < 60 * 60 * 1000 && cachedData) {

          const parsedData = JSON.parse(cachedData);

          const responseData = parsedData.data || parsedData;

          const mappedData = Array.isArray(responseData) ? responseData.map(item => ({

            ...item,

            originalName: item.tool || item.originalName || item.name,

            name: translateToolName(item.tool || item.originalName || item.name)

          })) : responseData;

          setColorData(mappedData);

          setLoadingColor(false);

          return;

        }



        const dateParams = calculateDateRange(selectedRange);

        const requestBody = {

          domain: domain,

          user_id: user.id,

          ...dateParams,

        };



        const response = await api.post("/color-tools", requestBody);

        const responseData = response.data?.data || response.data;



        // Mapear datos para incluir originalName si no existe

        const mappedData = Array.isArray(responseData) ? responseData.map(item => ({

          ...item,

          originalName: item.tool || item.originalName || item.name,

          name: translateToolName(item.tool || item.originalName || item.name)

        })) : responseData;



        setColorData(mappedData);



        // Guardar en caché

        localStorage.setItem(cacheKey, JSON.stringify(response.data));

        localStorage.setItem(timestampKey, now.toString());



      } catch (error) {



        // Intentar usar caché expirado

        const cacheKey = `color-data-${domain}-${selectedRange}`;

        const cachedData = localStorage.getItem(cacheKey);

        if (cachedData) {

          const parsedData = JSON.parse(cachedData);

          const responseData = parsedData.data || parsedData;

          const mappedData = Array.isArray(responseData) ? responseData.map(item => ({

            ...item,

            originalName: item.tool || item.originalName || item.name,

            name: translateToolName(item.tool || item.originalName || item.name)

          })) : responseData;

          setColorData(mappedData);

        } else {

          setColorData([]);

        }

      } finally {

        setLoadingColor(false);

      }

    },

    [dateRange, domain, user, translateToolName]

  );



  const fetchContentData = useCallback(

    async (selectedRange = dateRange) => {

      if (!user || !user.id) {

        setLoadingContent(false);

        return;

      }



      try {

        setLoadingContent(true);



        // Verificar caché

        const now = Date.now();

        const cacheKey = `content-data-${domain}-${selectedRange}`;

        const timestampKey = `content-timestamp-${domain}-${selectedRange}`;

        const lastFetch = localStorage.getItem(timestampKey);

        const cachedData = localStorage.getItem(cacheKey);



        if (lastFetch && now - lastFetch < 60 * 60 * 1000 && cachedData) {

          const parsedData = JSON.parse(cachedData);

          const responseData = parsedData.data || parsedData;

          const mappedData = Array.isArray(responseData) ? responseData.map(item => ({

            ...item,

            originalName: item.tool || item.originalName || item.name,

            name: translateToolName(item.tool || item.originalName || item.name)

          })) : responseData;

          setContentData(mappedData);

          setLoadingContent(false);

          return;

        }



        const dateParams = calculateDateRange(selectedRange);

        const requestBody = {

          domain: domain,

          user_id: user.id,

          ...dateParams,

        };



        const response = await api.post("/content-tools", requestBody);

        const responseData = response.data?.data || response.data;



        // Mapear datos para incluir originalName si no existe

        const mappedData = Array.isArray(responseData) ? responseData.map(item => ({

          ...item,

          originalName: item.tool || item.originalName || item.name,

          name: translateToolName(item.tool || item.originalName || item.name)

        })) : responseData;



        setContentData(mappedData);



        // Guardar en caché

        localStorage.setItem(cacheKey, JSON.stringify(response.data));

        localStorage.setItem(timestampKey, now.toString());



      } catch (error) {



        // Intentar usar caché expirado

        const cacheKey = `content-data-${domain}-${selectedRange}`;

        const cachedData = localStorage.getItem(cacheKey);

        if (cachedData) {

          const parsedData = JSON.parse(cachedData);

          const responseData = parsedData.data || parsedData;

          // CAMBIAR: Usar datos directos

          setContentData(responseData);

        } else {

          setContentData([]);

        }

      } finally {

        setLoadingContent(false);

      }

    },

    [dateRange, domain, user, translateToolName]

  );



  const pdfRef = useRef();



    // Función para descargar PDF

  const handleDownloadPDF = async () => {
    const input = pdfRef.current;

    if (!input) return;

    window.scrollTo(0, 0);

    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#fff",
      windowWidth: document.body.scrollWidth,
    });

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 20;
    const printableWidth = pageWidth - margin * 2;
    const printableHeight = pageHeight - margin * 2;
    const sliceHeight = Math.floor((printableHeight * canvas.width) / printableWidth);

    let remainingHeight = canvas.height;
    let sourceY = 0;
    let pageIndex = 0;

    while (remainingHeight > 0) {
      const currentSliceHeight = Math.min(sliceHeight, remainingHeight);
      const pageCanvas = document.createElement("canvas");
      const pageContext = pageCanvas.getContext("2d");

      pageCanvas.width = canvas.width;
      pageCanvas.height = currentSliceHeight;

      pageContext.fillStyle = "#fff";
      pageContext.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
      pageContext.drawImage(
        canvas,
        0,
        sourceY,
        canvas.width,
        currentSliceHeight,
        0,
        0,
        canvas.width,
        currentSliceHeight
      );

      if (pageIndex > 0) {
        pdf.addPage();
      }

      const pageImage = pageCanvas.toDataURL("image/jpeg", 0.9);
      const renderedHeight = (currentSliceHeight * printableWidth) / canvas.width;
      pdf.addImage(pageImage, "JPEG", margin, margin, printableWidth, renderedHeight);

      sourceY += currentSliceHeight;
      remainingHeight -= currentSliceHeight;
      pageIndex += 1;
    }

    pdf.save(`Estadisticas-${domain}.pdf`);
  };



  // Manejar cambio de rango de fechas - ACTUALIZADO para obtener ambos tipos de datos

  const handleDateRangeChange = (event) => {

    const newRange = event.target.value;

    setDateRange(newRange);



    // Obtener tanto access profile como métricas con el nuevo rango

    fetchAccessProfile(newRange);

    fetchMetrics(newRange);

    fetchNavigationData(newRange);

    fetchColorData(newRange);

    fetchContentData(newRange);

  };



  // Funciones para manejar toggle con scroll automático

  const handleToggleProfiles = () => {

    const newExpandedState = !isProfilesExpanded;

    setIsProfilesExpanded(newExpandedState);

    if (newExpandedState && profilesCardRef.current) {

      setTimeout(() => {

        profilesCardRef.current.scrollIntoView({

          behavior: "smooth",

          block: "start",

          inline: "nearest",

        });

      }, 100);

    }

  };



  const handleToggleNavigation = () => {

    const newExpandedState = !isNavigationExpanded;

    setIsNavigationExpanded(newExpandedState);

    if (newExpandedState && navigationCardRef.current) {

      setTimeout(() => {

        navigationCardRef.current.scrollIntoView({

          behavior: "smooth",

          block: "start",

          inline: "nearest",

        });

      }, 100);

    }

  };



  const handleToggleColor = () => {

    const newExpandedState = !isColorExpanded;

    setIsColorExpanded(newExpandedState);

    if (newExpandedState && colorCardRef.current) {

      setTimeout(() => {

        colorCardRef.current.scrollIntoView({

          behavior: "smooth",

          block: "start",

          inline: "nearest",

        });

      }, 100);

    }

  };



  const handleToggleContent = () => {

    const newExpandedState = !isContentExpanded;

    setIsContentExpanded(newExpandedState);

    if (newExpandedState && contentCardRef.current) {

      setTimeout(() => {

        contentCardRef.current.scrollIntoView({

          behavior: "smooth",

          block: "start",

          inline: "nearest",

        });

      }, 100);

    }

  };



  // // AGREGAR funciones para el modal de guías

  // const handleOpenGuides = () => {

  //   setGuidesModalOpen(true);

  // };



  const handleCloseGuides = () => {

    setGuidesModalOpen(false);

  };



  // Procesar datos para gráficas de área - ACTUALIZADO

  const processAccessProfileForChart = (data) => {

    if (!Array.isArray(data)) return [];



    return data

      .map((item) => {

        // Si el item es un array [fecha, valor]

        if (Array.isArray(item) && item.length >= 2) {

          const [dateStr, value] = item;

          const date = new Date(dateStr);



          return {

            name: date.toLocaleDateString(i18n.language === 'en' ? 'en-US' : 'es-ES', {

              month: "short",

              day: "numeric",

            }),

            value: typeof value === "number" ? value : 0,

            fullDate: dateStr,

            date: dateStr,

          };

        }



        // Fallback para otros formatos

        return {

          name: `Día ${data.indexOf(item) + 1}`,

          value: item.value || item || 0,

          date: item.date || `${data.indexOf(item) + 1}`,

        };

      })

      .sort(

        (a, b) =>

          new Date(a.fullDate || a.date) - new Date(b.fullDate || b.date)

      );

  };



  // Función actualizada para procesar métricas con la nueva estructura [fecha, perfil, cantidad]
  const processMetricsForChart = (metricsData) => {
    if (!Array.isArray(metricsData)) {
      return [];
    }

    // CAMBIAR: Combinar todos los dailyData de todos los perfiles por fecha

    const dataByDate = {};



    metricsData.forEach((profile) => {

      if (profile.dailyData && typeof profile.dailyData === "object") {

        Object.entries(profile.dailyData).forEach(([date, count]) => {

          if (!dataByDate[date]) {

            dataByDate[date] = { date, total: 0 };

          }

          dataByDate[date].total += count || 0;

        });

      }

    });



    // Convertir a array y ordenar por fecha

    let chartData = Object.values(dataByDate)

      .sort((a, b) => new Date(a.date) - new Date(b.date))

      .map((item) => ({

        name: new Date(item.date).toLocaleDateString(i18n.language === 'en' ? 'en-US' : 'es-ES', {

          month: "short",

          day: "numeric",

        }),

        value: item.total,

        fullDate: item.date,

      }));



    // En móvil, reducir datos mostrando cada N días

    if (window.innerWidth < 600 && chartData.length > 10) {

      const step = Math.ceil(chartData.length / 10);

      chartData = chartData.filter((_, index) => index % step === 0);

    }



    return chartData;

  };



  // Nueva función para procesar datos de la leyenda de perfiles

  const processMetricsForLegend = useCallback((metricsData) => {



    if (!Array.isArray(metricsData)) {

      return [];

    }



    // CAMBIAR: Usar directamente los datos que ya vienen procesados

    const legendData = metricsData

      .map((profile) => ({

        name: translateProfileName(profile.originalName || profile.profile || profile.name), // Traducir nombre

        value: profile.value, // Ya viene calculado del servidor

        profile: profile.originalName || profile.profile,

      }))

      .sort((a, b) => b.value - a.value); // Ordenar por uso descendente



    return legendData;

  }, [translateProfileName]);

  const calculateTotalProfilesUsed = (metricsData) => {

    if (!Array.isArray(metricsData)) return 0;



    return metricsData.reduce((sum, profile) => sum + (profile.value || 0), 0);

  };



  // AGREGAR el componente ProfilesTooltip que falta:

  const ProfilesTooltip = ({ active, payload, label }) => {

    if (active && payload && payload.length) {

      const data = payload[0].payload;

      return (

        <div

          style={{

            backgroundColor: "#fff",

            border: "1px solid #E0E0E0",

            borderRadius: "8px",

            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",

            padding: "12px",

          }}

        >

          <p

            style={{

              margin: 0,

              fontWeight: "bold",

              fontSize: "14px",

            }}

          >

            {data.fullDate

              ? new Date(data.fullDate).toLocaleDateString(i18n.language === 'en' ? 'en-US' : 'es-ES', {

                  weekday: "long",

                  year: "numeric",

                  month: "long",

                  day: "numeric",

                })

              : label}

          </p>

          <p

            style={{

              margin: "4px 0 0 0",

              color: "#0F52BD",

              fontSize: "16px",

              fontWeight: "bold",

            }}

          >

            {payload[0].value} {t("widgetStatistics.profileActivations")}

          </p>

        </div>

      );

    }

    return null;

  };



  // Effects

  useEffect(() => {

    if (user && user.id && domain) {

      fetchMetrics(dateRange); // Pasar el rango actual

      fetchAccessProfile(dateRange); // Pasar el rango actual

      fetchNavigationData(dateRange);

      fetchColorData(dateRange);

      fetchContentData(dateRange);

    }

  }, [

    domain,

    user,

    dateRange,

    fetchMetrics,

    fetchAccessProfile,

    fetchNavigationData,

    fetchColorData,

    fetchContentData,

  ]);



  // Loading state

  if (loading && accessProfileLoading) {

    return (

      <Container maxWidth="sm" sx={{ mt: 10, textAlign: "center" }}>

        <CircularProgress />

        <Typography sx={{ mt: 2 }}>

          {t("widgetStatistics.loadingMetrics")}

        </Typography>

      </Container>

    );

  }



  // Procesar datos para las gráficas - actualizado

  const accessChartData = processAccessProfileForChart(accessProfileData);

  const metricsChartData = processMetricsForChart(metrics); // Ahora usa dailyData

  const metricsLegendData = processMetricsForLegend(metrics); // Ahora usa el formato de objetos

  const totalProfilesUsed = calculateTotalProfilesUsed(metrics); // Nueva función



  // Log para verificar datos finales



  // Componente reutilizable para las tarjetas - CON GRÁFICAS

  // Componente reutilizable para las tarjetas - CON GRÁFICAS TEMPORALES

  const AccessibilityToolCard = ({

    title,

    data,

    loading,

    isExpanded,

    onToggle,

    cardRef,

    iconColor = "#0F52BD",

  }) => {

    // VALIDAR que data sea un array

    const safeData = Array.isArray(data) ? data : [];



    // Procesar datos para gráfica temporal (como access-profile)

    // En AccessibilityToolCard - ACTUALIZAR processDataForChart

    const processDataForChart = (toolsData) => {

      if (!Array.isArray(toolsData) || toolsData.length === 0) return [];





      // Combinar todos los dailyData de todas las herramientas por fecha

      const dataByDate = {};



      toolsData.forEach((tool) => {

        if (tool.dailyData && typeof tool.dailyData === "object") {

          Object.entries(tool.dailyData).forEach(([date, count]) => {

            if (!dataByDate[date]) {

              dataByDate[date] = { date, total: 0 };

            }

            dataByDate[date].total += count || 0;

          });

        }

      });



      // Convertir a array y ordenar por fecha

      const chartData = Object.values(dataByDate)

        .sort((a, b) => new Date(a.date) - new Date(b.date))

        .map((item) => ({

          name: new Date(item.date).toLocaleDateString(i18n.language === 'en' ? 'en-US' : 'es-ES', {

            month: "short",

            day: "numeric",

          }),

          value: item.total,

          fullDate: item.date,

          date: item.date,

        }));



      return chartData;

    };



    



    const chartData = processDataForChart(safeData);



    return (

      <Card

        ref={cardRef}

        sx={{

          boxShadow: "0px 4px 10px 0px rgba(98, 113, 137, 0.46)",

          borderRadius: 3,

          p: 3,

          position: "relative",

          transition: "all 0.4s ease-in-out",

          height: isExpanded ? "auto" : { xs: "auto", md: "120px" }, // CAMBIAR: altura automática en móvil, fija en desktop

          minHeight: isExpanded ? "auto" : { xs: "200px", md: "120px" }, // AÑADIR: altura mínima mayor en móvil

          overflow: "hidden",

          scrollMarginTop: "20px",

          mb: 4,

        }}

      >

        {/* Flecha para colapsar/expandir */}

        <Box

          onClick={onToggle}

          sx={{

            position: "absolute",

            top: 24,

            right: 32,

            transform: "none",

            cursor: "pointer",

            display: "flex",

            alignItems: "center",

            justifyContent: "center",

            width: 32,

            height: 32,

            transition: "all 0.3s ease",

            zIndex: 20,

            "&:hover": {

              transform: "scale(1.1)",

            },

          }}

        >

          <svg

            width="20"

            height="20"

            viewBox="0 0 16 16"

            fill="none"

            xmlns="http://www.w3.org/2000/svg"

            style={{

              transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",

              transition: "transform 0.3s ease",

            }}

          >

            <path

              d="M4 6L8 10L12 6"

              stroke="#666"

              strokeWidth="2"

              strokeLinecap="round"

              strokeLinejoin="round"

            />

          </svg>

        </Box>



        {loading ? (

          <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>

            <CircularProgress />

          </Box>

        ) : (

          <Box sx={{ pr: 8 }}>

            {/* <Typography sx={{ fontWeight: 'bold', fontSize: 18, mb: 2 }}>

            {title}

          </Typography> */}

            {/* Mostrar mensaje si no hay datos */}

            {safeData.length === 0 ? (

              <Box

                sx={{

                  py: 4,

                  textAlign: "center",

                  color: "#666",

                }}

              >

                <Typography

                  variant="h6"

                  sx={{

                    mb: 2,

                    fontWeight: "bold",

                    fontSize: "18px",

                    color: "#333",

                  }}

                >

                  {title}

                </Typography>

                <Typography variant="body2">

                  No hay datos disponibles para este período

                </Typography>

              </Box>

            ) : isExpanded ? (

              <Box

                sx={{

                  animation: isExpanded

                    ? "fadeInExpand 0.4s ease-in-out"

                    : "none",

                  "@keyframes fadeInExpand": {

                    "0%": {

                      opacity: 0,

                      transform: "translateY(-20px)",

                    },

                    "100%": {

                      opacity: 1,

                      transform: "translateY(0)",

                    },

                  },

                }}

              >

                <Typography

                  variant="h6"

                  sx={{ mb: 3, fontWeight: "bold", fontSize: "18px" }}

                >

                  {title}

                </Typography>

                {/* Vista expandida con gráfica temporal y leyenda (como perfiles) */}

                <Grid container spacing={3} alignItems="stretch">

                  {/* Gráfica temporal a la izquierda */}

                  <Grid item xs={12} md={8}>

                    <Box sx={{ height: "100%", minHeight: 500 }}>

                      <ResponsiveContainer width="100%" height="100%">

                        <AreaChart

                          data={chartData}

                          margin={{ 

                            top: window.innerWidth < 600 ? 10 : 20, 

                            right: window.innerWidth < 600 ? 5 : 30, 

                            left: window.innerWidth < 600 ? -10 : 20, 

                            bottom: 0 

                          }}

                        >

                          <defs>

                            <linearGradient

                              id={`color${title.replace(/\s+/g, "")}`}

                              x1="0"

                              y1="0"

                              x2="0"

                              y2="1"

                            >

                              <stop

                                offset="5%"

                                stopColor={iconColor}

                                stopOpacity={0.4}

                              />

                              <stop

                                offset="95%"

                                stopColor={iconColor}

                                stopOpacity={0}

                              />

                            </linearGradient>

                          </defs>

                          <CartesianGrid

                            strokeDasharray="3 3"

                            stroke="#E0E0E0"

                          />

                          <XAxis

                            dataKey="name"

                            tick={{ fontSize: window.innerWidth < 600 ? 8 : 11 }}

                            stroke="#666"

                            angle={window.innerWidth < 600 ? -45 : 0}

                            textAnchor={window.innerWidth < 600 ? "end" : "middle"}

                            height={window.innerWidth < 600 ? 60 : 30}

                          />

                          <YAxis

                            tick={{ fontSize: window.innerWidth < 600 ? 9 : 12 }}

                            stroke="#666"

                            domain={[0, "dataMax + 10%"]}

                            allowDataOverflow={false}

                            type="number"

                            tickCount={window.innerWidth < 600 ? 5 : 8}

                          />

                          <Tooltip

                            content={({ active, payload, label }) => {

                              if (active && payload && payload.length) {

                                const data = payload[0].payload;

                                return (

                                  <div

                                    style={{

                                      backgroundColor: "#fff",

                                      border: "1px solid #E0E0E0",

                                      borderRadius: "8px",

                                      boxShadow: "0 4px 10px rgba(0,0,0,0.1)",

                                      padding: "12px",

                                    }}

                                  >

                                    <p

                                      style={{

                                        margin: 0,

                                        fontWeight: "bold",

                                        fontSize: "14px",

                                      }}

                                    >

                                      {data.fullDate

                                        ? new Date(

                                            data.fullDate

                                          ).toLocaleDateString(i18n.language === 'en' ? 'en-US' : 'es-ES', {

                                            weekday: "long",

                                            year: "numeric",

                                            month: "long",

                                            day: "numeric",

                                          })

                                        : label}

                                    </p>

                                    <p

                                      style={{

                                        margin: "4px 0 0 0",

                                        color: iconColor,

                                        fontSize: "16px",

                                        fontWeight: "bold",

                                      }}

                                    >

                                      {payload[0].value} {t("widgetStatistics.toolsUsage")}

                                    </p>

                                  </div>

                                );

                              }

                              return null;

                            }}

                          />

                          <Area

                            type="monotone"

                            dataKey="value"

                            stroke={iconColor}

                            strokeWidth={2}

                            fillOpacity={1}

                            fill={`url(#color${title.replace(/\s+/g, "")})`}

                            connectNulls={false}

                            dot={false}

                            activeDot={{ r: 4, fill: iconColor }}

                          />

                        </AreaChart>

                      </ResponsiveContainer>

                    </Box>

                  </Grid>



                  {/* Panel derecho con tarjetas (como perfiles) */}

                  <Grid item xs={12} md={4}>

                    <Box

                      sx={{

                        display: "flex",

                        flexDirection: "column",

                        gap: 3,

                        height: "100%",

                        minHeight: 500,

                      }}

                    >

                      {/* Subtarjeta con total de herramientas */}

                      <Paper

                        sx={{

                          p: 3,

                          textAlign: "center",

                          boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",

                          borderRadius: 2,

                        }}

                      >

                        <Box

                          sx={{

                            width: 40,

                            height: 40,

                            borderRadius: "50%",

                            bgcolor: iconColor,

                            display: "flex",

                            alignItems: "center",

                            justifyContent: "center",

                            margin: "0 auto",

                            mb: 1,

                            color: "white",

                            fontSize: "20px",

                            fontWeight: "bold",

                          }}

                        >

                          {title.charAt(0)}

                        </Box>

                        <Typography

                          variant="h4"

                          sx={{

                            fontSize: "32px",

                            fontWeight: "bold",

                            color: iconColor,

                            mb: 1,

                          }}

                        >

                          {safeData

                            .reduce(

                              (total, item) => total + (item.value || 0),

                              0

                            )

                            .toLocaleString()}

                        </Typography>

                        <Typography variant="body2" sx={{ color: "#666" }}>

                          {t("widgetStatistics.mostUsedTools")}

                        </Typography>

                      </Paper>



                      {/* Subtarjeta con leyenda de herramientas (como perfiles) */}

                      <Paper

                        sx={{

                          p: 2,

                          boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",

                          borderRadius: 2,

                          flex: 1,

                          overflow: "auto",

                        }}

                      >

                        <Typography

                          variant="subtitle1"

                          sx={{

                            fontWeight: "bold",

                            mb: 2,

                            fontSize: "16px",

                          }}

                        >

                          {t("widgetStatistics.toolsLegend")}

                        </Typography>

                        <List dense>

                          {safeData.map((item, index) => (

                            <ListItem key={index} sx={{ py: 0.5 }}>

                              <Box

                                sx={{

                                  width: 12,

                                  height: 12,

                                  backgroundColor:

                                    index === 0 ? iconColor : `${iconColor}80`,

                                  borderRadius: "50%",

                                  mr: 1,

                                  flexShrink: 0,

                                }}

                              />

                              <ListItemText

                                primary={

                                  <Box

                                    sx={{

                                      display: "flex",

                                      justifyContent: "space-between",

                                      alignItems: "center",

                                    }}

                                  >

                                    <Typography

                                      variant="body2"

                                      sx={{ fontSize: "12px" }}

                                    >

                                      {translateToolName(item.originalName || item.tool || item.name)}

                                    </Typography>

                                    <Chip

                                      label={item.value}

                                      size="small"

                                      sx={{

                                        height: 20,

                                        fontSize: "10px",

                                        backgroundColor:

                                          index === 0 ? iconColor : "#E0E0E0",

                                        color: index === 0 ? "white" : "#666",

                                      }}

                                    />

                                  </Box>

                                }

                              />

                            </ListItem>

                          ))}

                        </List>

                      </Paper>

                    </Box>

                  </Grid>

                </Grid>

              </Box>

            ) : (

              /* Vista colapsada - horizontal */

              <Box

                sx={{

                  display: "flex",

                  alignItems: "center",

                  justifyContent: "space-between",

                  height: { xs: "auto", md: "60px" }, // CAMBIAR: altura automática en móvil

                  width: "100%",

                  flexDirection: { xs: "column", md: "row" }, // CAMBIAR: stack vertical en móvil

                  gap: { xs: 2, md: 0 }, // CAMBIAR: gap en móvil

                  py: { xs: 0, md: 0 }, // CAMBIAR: padding vertical en móvil

                  animation: !isExpanded

                    ? "fadeInCollapse 0.4s ease-in-out"

                    : "none",

                  "@keyframes fadeInCollapse": {

                    "0%": {

                      opacity: 0,

                      transform: "translateY(20px)",

                    },

                    "100%": {

                      opacity: 1,

                      transform: "translateY(0)",

                    },

                  },

                }}

              >

                {/* Título y descripción */}

                <Box

                  sx={{

                    width: { xs: "100%", md: "300px" }, // CAMBIAR: full width en móvil

                    minWidth: { xs: "100%", md: "300px" }, // CAMBIAR: responsive min width

                    maxWidth: { xs: "100%", md: "300px" }, // CAMBIAR: responsive max width

                    pr: { xs: 0, md: 2 }, // CAMBIAR: sin padding right en móvil

                    textAlign: { xs: "center", md: "left" }, // CAMBIAR: centrado en móvil

                  }}

                >

                  <Typography

                    variant="h6"

                    sx={{

                      fontWeight: "bold",

                      fontSize: { xs: "18px", md: "20px" }, // CAMBIAR: más pequeño en móvil

                      mb: { xs: 0, md: 1 }, // CAMBIAR: menos margin en móvil

                      lineHeight: 1.2,

                    }}

                  >

                    {title}

                  </Typography>

                  <Typography

                    variant="body2"

                    sx={{

                      color: "#666",

                      fontSize: { xs: "12px", md: "14px" }, // CAMBIAR: más pequeño en móvil

                      lineHeight: 1.3,

                      display: { xs: "none", sm: "block" }, // CAMBIAR: ocultar en móvil muy pequeño

                    }}

                  >

                    {t("widgetStatistics.mostUsedTools")}

                  </Typography>

                </Box>



                {/* Contador total */}

                <Box

                  sx={{

                    width: { xs: "100%", md: "240px" }, // CAMBIAR: full width en móvil

                    minWidth: { xs: "100%", md: "240px" }, // CAMBIAR: responsive min width

                    maxWidth: { xs: "100%", md: "240px" }, // CAMBIAR: responsive max width

                    display: "flex",

                    alignItems: "baseline",

                    gap: { xs: 1, md: 1.5 }, // CAMBIAR: menos gap en móvil

                    justifyContent: "center",

                    order: { xs: 2, md: 0 }, // CAMBIAR: último en móvil

                  }}

                >

                  <Typography

                    variant="h4"

                    sx={{

                      fontSize: { xs: "24px", md: "32px" }, // CAMBIAR: más pequeño en móvil

                      fontWeight: "bold",

                      color: "#000",

                      lineHeight: 1,

                    }}

                  >

                    {safeData

                      .reduce((total, item) => total + (item.value || 0), 0)

                      .toLocaleString()}

                  </Typography>

                  <Typography

                    variant="body1"

                    sx={{

                      color: "#666",

                      fontSize: { xs: "14px", md: "16px" }, // CAMBIAR: más pequeño en móvil

                      fontWeight: "medium",

                    }}

                  >

                    {t("widgetStatistics.uses")}

                  </Typography>

                </Box>



                {/* Herramienta más utilizada */}

                {safeData.length > 0 && (

                  <Box

                    sx={{

                      width: { xs: "100%", md: "220px" }, // CAMBIAR: full width en móvil

                      minWidth: { xs: "100%", md: "220px" }, // CAMBIAR: responsive min width

                      maxWidth: { xs: "100%", md: "220px" }, // CAMBIAR: responsive max width

                      display: "flex",

                      justifyContent: { xs: "center", md: "flex-end" }, // CAMBIAR: centrar en móvil

                      order: { xs: 3, md: 0 }, // CAMBIAR: segundo en móvil

                    }}

                  >

                    <Paper

                      sx={{

                        p: { xs: 1.5, md: 2 }, // CAMBIAR: menos padding en móvil

                        width: { xs: "100%", md: "auto" }, // CAMBIAR: full width en móvil

                        minWidth: { xs: "100%", md: "180px" }, // CAMBIAR: responsive min width

                        maxWidth: { xs: "100%", md: "180px" }, // CAMBIAR: responsive max width

                        boxShadow: `0px 4px 10px 0px ${iconColor}46`,

                        borderRadius: 2,

                        position: "relative",

                        display: "flex",

                        alignItems: "center",

                        justifyContent: "center",

                      }}

                    >

                      {/* Indicador #1 */}

                      <Box

                        sx={{

                          position: "absolute",

                          top: { xs: -6, md: -8 }, // CAMBIAR: ajustar posición en móvil

                          right: { xs: 6, md: 8 }, // CAMBIAR: ajustar posición en móvil

                          width: { xs: 20, md: 24 }, // CAMBIAR: más pequeño en móvil

                          height: { xs: 20, md: 24 }, // CAMBIAR: más pequeño en móvil

                          borderRadius: "4px",

                          backgroundColor: iconColor,

                          color: "white",

                          display: "flex",

                          alignItems: "center",

                          justifyContent: "center",

                          fontSize: { xs: "10px", md: "12px" }, // CAMBIAR: más pequeño en móvil

                          fontWeight: "bold",

                          zIndex: 1,

                        }}

                      >

                        #1

                      </Box>



                      {/* Texto centrado */}

                      <Box

                        sx={{

                          textAlign: "center",

                          px: { xs: 0.5, md: 1 }, // CAMBIAR: menos padding en móvil

                          width: "100%", // CAMBIAR: asegurar que ocupe todo el ancho

                          overflow: "hidden", // CAMBIAR: prevenir overflow

                        }}

                      >

                        <Typography

                          variant="body2"

                          sx={{

                            fontSize: { xs: "14px", md: "16px" }, // CAMBIAR: más pequeño en móvil

                            fontWeight: "bold",

                            lineHeight: 1.2,

                            color: "#333",

                            wordBreak: "break-word",

                            whiteSpace: "normal",

                            hyphens: "auto",

                            overflow: "hidden", // CAMBIAR: prevenir overflow

                            textOverflow: "ellipsis", // CAMBIAR: truncar si es necesario

                            display: "-webkit-box", // CAMBIAR: para multiline truncation

                            WebkitLineClamp: { xs: 2, md: 3 }, // CAMBIAR: limitar líneas

                            WebkitBoxOrient: "vertical", // CAMBIAR: orientación vertical

                          }}

                        >

                          {safeData[0] ? translateToolName(safeData[0].originalName || safeData[0].tool || safeData[0].name) : t("widgetStatistics.tool")}

                        </Typography>

                      </Box>

                    </Paper>

                  </Box>

                )}

              </Box>

            )}

          </Box>

        )}

      </Card>

    );

  };

  return (

    <>

    <Box

      sx={{

        display: "flex",

        flexDirection: "column",

        width: "100%",

        maxWidth: "100vw",

        px: { xs: 0, md: 2.5 },

        py: { xs: 0, md: 4 },

        pb: 0,

        mr: { xs: -6 },

        pr: { xs: 0 },

      }}

    >

      {/* Cabecera fija */}

      <Box

        sx={{

          display: "flex",

          flexDirection: "column",

          width: "100%",

          position: "fixed",

          top: 0,

          left: 0,

          right: 0,

          padding: { xs: "12px 16px", sm: "8px 16px", md: "12px 16px" },

          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",

          backgroundColor: "white",

          zIndex: 1000,

        }}

      >

        <Box

          sx={{

            display: "flex",

            justifyContent: "space-between",

            alignItems: "center",

            width: "100%",

          }}

        >

          <Box sx={{ 

            display: { xs: "flex", sm: "flex" }, 

            flexDirection: "row", 

            alignItems: "center",

            flex: 1,

            ml: { xs: "50px", sm: "50px", md: 35.5 },

          }}>

            <Typography

              variant="h5"

              sx={{

                fontSize: { xs: "16px", sm: "18px", md: "14px", lg: "20px" },

                fontWeight: "medium",

                color: "#000",

              }}

            >

              {t("widgetStatistics.statisticsFor")} <span style={{ color: "#0F52BD" }}>{domain}</span>

            </Typography>

          </Box>



          <Box

            sx={{

              display: "flex",

              gap: '5px',

              mr: { xs: 1.5, md: 5 },

              alignItems: "center",

            }}

          >

            <Typography 

              variant="subtitle1" 

              sx={{ 

                fontSize: '16px', 

                color: '#666',

                display: { xs: "none", lg: "block" },

                ml: { lg: 3 },

              }}

            >

              {t("widgetStatistics.subtitle")}

            </Typography>



            {/* Botón de volver - Solo icono en móvil */}

            <Box sx={{ display: { xs: "block", sm: "none" } }}>

              <IconButton

                onClick={() => navigate("/dashboard")}

                sx={{

                  color: "#0F52BD",

                  backgroundColor: "transparent",

                  borderRadius: "8px",

                  "&:hover": { backgroundColor: "#E3F2FD" },

                  width: 40,

                  height: 40,

                }}

              >

                <ArrowBackIcon sx={{ fontSize: "24px" }} />

              </IconButton>

            </Box>



            {/* Botón de volver - Con texto en tablet/desktop */}

            <Box sx={{ display: { xs: "none", sm: "block" } }}>

              <Button

                variant="contained"

                startIcon={<ArrowBackIcon />}

                onClick={() => navigate("/dashboard")}

                sx={{

                  textTransform: "none",

                  fontWeight: "medium",

                  backgroundColor: "#0F52BD",

                  fontSize: { sm: "14px", md: "14px" },

                  px: { sm: 1, md: 1 },

                  py: { sm: 0.6, md: 0.6 },

                  borderRadius: "8px",

                }}

              >

                {t("home.backToDashboard")}

              </Button>

            </Box>



            {/* Botón exportar PDF - Solo icono en móvil */}

            <Box sx={{ display: { xs: "block", sm: "none" } }}>

              <IconButton

                onClick={handleDownloadPDF}

                sx={{

                  color: "#0F52BD",

                  backgroundColor: "transparent",

                  borderRadius: "8px",

                  "&:hover": { backgroundColor: "#E3F2FD" },

                  width: 40,

                  height: 40,

                }}

              >

                <PictureAsPdfIcon sx={{ fontSize: "24px" }} />

              </IconButton>

            </Box>



            {/* Botón exportar PDF - Con texto en tablet/desktop */}

            <Box sx={{ display: { xs: "none", sm: "block" } }}>

              <Button

                variant="outlined"

                onClick={handleDownloadPDF}

                sx={{

                  textTransform: "none",

                  fontWeight: "medium",

                  color: "#0F52BD",

                  borderColor: "#0F52BD",

                  fontSize: { sm: "14px", md: "14px" },

                  px: { sm: 1, md: 1 },

                  py: { sm: 0.6, md: 0.6 },

                  borderWidth: "2px",

                  borderRadius: "8px",

                }}

              >

                {t("Exportar PDF")}

              </Button>

            </Box>

          </Box>

        </Box>

      </Box>



      {/* Spacer para empujar el contenido hacia abajo */}

      <Box

        sx={{

          height: { xs: "65px", sm: "70px", md: "100px", lg: "90px" },

          "@media (max-width: 600px) and (min-resolution: 1.25dppx)": {

            height: "65px",

          },

          "@media (max-width: 600px) and (min-resolution: 1.5dppx)": {

            height: "90px",

          },

          "@media (min-width: 600px) and (min-resolution: 1.25dppx)": {

            height: "75px",

          },

          "@media (min-width: 900px) and (min-resolution: 1.25dppx)": {

            height: "95px",

          },

        }}

      />



      <Box

        sx={{

          paddingLeft: { xs: 2, md: 2 },

          paddingRight: { xs: 2, md: 4 },

        }}

      >

      <Box

        ref={pdfRef}

        sx={{

          pb: 0,

          pt: { xs: 0, md: 2 },

        }}

      >

        <Container maxWidth="xl" sx={{ p: 0 }}>

          {/* MOVER el selector de rango de fechas aquí y simplificarlo */}

          <Box

            sx={{

              display: "flex",

              justifyContent: { xs: "center", md: "space-between" }, // CAMBIAR: centrar en móvil

              alignItems: { xs: "center", md: "center" }, // CAMBIAR: responsive alignment

              flexDirection: { xs: "column", md: "row" }, // CAMBIAR: stack en móvil

              gap: { xs: 2, md: 0 }, // CAMBIAR: gap para móvil

              mb: 4,

              p: { xs: 2, md: 2 }, // CAMBIAR: responsive padding

              backgroundColor: "#f8f9fa",

              borderRadius: 2,

              ml: { xs: 0, md: 4 },

              mr: { xs: 0, md: 4 },

            }}

          >

            <Typography

              variant="h4"

              sx={{

                fontWeight: "bold",

                fontSize: { xs: "20px", sm: "24px", md: "28px" }, // CAMBIAR: responsive font size

                textAlign: { xs: "center", md: "left" }, // CAMBIAR: center en móvil

                mb: { xs: 0, md: 0 }, // CAMBIAR: sin margin bottom en móvil ya que está apilado

              }}

            >

              {t("widgetStatistics.activitySummary")}

            </Typography>



            <FormControl

              sx={{

                minWidth: { xs: 280, md: 200 }, // CAMBIAR: más ancho en móvil para mejor usabilidad

                width: { xs: "100%", sm: "auto" }, // CAMBIAR: full width en móvil pequeño

                maxWidth: { xs: "100%", md: 200 }, // CAMBIAR: limitar ancho máximo

              }}

            >

              <Select

                value={dateRange}

                onChange={handleDateRangeChange}

                displayEmpty

                sx={{

                  backgroundColor: "white",

                  fontSize: { xs: "14px", md: "16px" }, // CAMBIAR: responsive font size

                  "& .MuiOutlinedInput-notchedOutline": {

                    borderColor: "#0F52BD",

                  },

                  "& .MuiSelect-select": {

                    py: { xs: 1.5, md: 1 }, // CAMBIAR: responsive padding

                  },

                }}

              >

                {dateRangeOptions.map((option) => (

                  <MenuItem

                    key={option.value}

                    value={option.value}

                    sx={{

                      fontSize: { xs: "14px", md: "16px" }, // CAMBIAR: responsive font size en opciones

                    }}

                  >

                    {option.label}

                  </MenuItem>

                ))}

              </Select>

            </FormControl>

          </Box>



          {/* Resto del contenido existente con padding ajustado */}

          <Box

            sx={{

              paddingLeft: { xs: 0, md: 4 },

              paddingRight: { xs: 0, md: 4 },

            }}

          >

            {/* Tarjeta principal de access-profile - SIN CAMBIOS */}

            <Card

              sx={{

                boxShadow: "0px 4px 10px 0px rgba(98, 113, 137, 0.46)",

                borderRadius: 3,

                mb: 4,

                p: { xs: 2, md: 3 },

              }}

            >

              {accessProfileLoading ? (

                <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>

                  <CircularProgress />

                </Box>

              ) : (

                <Grid container spacing={4} alignItems="stretch">

                  {/* Contenido descriptivo a la izquierda */}

                  <Grid item xs={12} md={6}>

                    {/* Header con número y título EN LA MISMA LÍNEA */}

                    <Box

                      sx={{

                        display: "flex",

                        alignItems: "baseline",

                        gap: 2,

                        mb: 2,

                        flexWrap: "wrap",

                      }}

                    >

                      <Typography

                        variant="h2"

                        sx={{

                          fontSize: "48px",

                          fontWeight: "bold",

                          color: "#000",

                          lineHeight: 1,

                        }}

                      >

                        {totalAccessProfile.toLocaleString()}

                      </Typography>

                      <Typography

                        variant="h6"

                        sx={{

                          fontSize: "18px",

                          color: "#000",

                          fontWeight: "medium",

                        }}

                      >

                        {t("widgetStatistics.widgetOpenings")}

                      </Typography>

                    </Box>



                    {/* Línea divisoria azul */}

                    <Box

                      sx={{

                        width: "100%",

                        height: "2px",

                        backgroundColor: "#0F52BD",

                        mb: 3,

                      }}

                    />



                    {/* Párrafos descriptivos */}

                    <Box>

                      <Typography

                        variant="body1"

                        sx={{

                          fontSize: "16px",

                          color: "#333",

                          lineHeight: 1.6,

                          mb: 2,

                        }}

                      >

                        {t("widgetStatistics.openingsDescription")}

                      </Typography>

                      <Typography

                        variant="body1"

                        sx={{

                          fontSize: "16px",

                          color: "#333",

                          lineHeight: 1.6,

                        }}

                      >

                        {t("widgetStatistics.improveExperience")}

                      </Typography>

                    </Box>

                  </Grid>



                  {/* Gráfica a la derecha */}

                  <Grid item xs={12} md={6}>

                    <Box sx={{ height: 350 }}>

                      <ResponsiveContainer width="100%" height="100%">

                        <AreaChart 

                          data={accessChartData}

                          margin={{ top: 10, right: window.innerWidth < 600 ? 5 : 10, left: window.innerWidth < 600 ? -10 : 0, bottom: window.innerWidth < 600 ? 5 : 10 }}

                        >

                          <defs>

                            <linearGradient

                              id="colorAccessProfile"

                              x1="0"

                              y1="0"

                              x2="0"

                              y2="1"

                            >

                              <stop

                                offset="5%"

                                stopColor="#0F52BD"

                                stopOpacity={0.4}

                              />

                              <stop

                                offset="95%"

                                stopColor="#0F52BD"

                                stopOpacity={0}

                              />

                            </linearGradient>

                          </defs>

                          <CartesianGrid

                            strokeDasharray="3 3"

                            stroke="#E0E0E0"

                          />

                          <XAxis

                            dataKey="name"

                            tick={{ fontSize: window.innerWidth < 600 ? 8 : 12 }}

                            stroke="#666"

                            angle={window.innerWidth < 600 ? -45 : 0}

                            textAnchor={window.innerWidth < 600 ? "end" : "middle"}

                            height={window.innerWidth < 600 ? 60 : 30}

                          />

                          <YAxis

                            tick={{ fontSize: window.innerWidth < 600 ? 9 : 12 }}

                            stroke="#666"

                            domain={[0, (dataMax) => Math.max(dataMax, 1)]}

                            allowDataOverflow={false}

                            type="number"

                            scale="linear"

                          />

                          <Tooltip

                            contentStyle={{

                              backgroundColor: "#fff",

                              border: "1px solid #E0E0E0",

                              borderRadius: "8px",

                              boxShadow: "0 4px 10px rgba(0,0,0,0.1)",

                            }}

                          />

                          <Area

                            type="monotone"

                            dataKey="value"

                            stroke="#0F52BD"

                            strokeWidth={2}

                            fillOpacity={1}

                            fill="url(#colorAccessProfile)"

                          />

                        </AreaChart>

                      </ResponsiveContainer>

                    </Box>

                  </Grid>

                </Grid>

              )}

            </Card>



            {/* Tarjeta de perfiles de accesibilidad CON FUNCIONALIDAD COLAPSAR/EXPANDIR */}

            <Card

              ref={profilesCardRef}

              sx={{

                boxShadow: "0px 4px 10px 0px rgba(98, 113, 137, 0.46)",

                borderRadius: 3,

                p: { xs: 2, md: 3 },

                position: "relative",

                transition: "all 0.4s ease-in-out",

                height: isProfilesExpanded

                  ? "auto"

                  : { xs: "auto", md: "120px" }, // CAMBIAR: altura automática en móvil

                minHeight: isProfilesExpanded

                  ? "auto"

                  : { xs: "100px", md: "120px" }, // AÑADIR: altura mínima mayor en móvil

                overflow: "hidden",

                scrollMarginTop: "20px",

                mb: 4,

              }}

            >

              {/* Flecha para colapsar/expandir */}

              <Box

                onClick={handleToggleProfiles}

                sx={{

                  position: "absolute",

                  top: 24,

                  right: 32,

                  transform: "none",

                  cursor: "pointer",

                  display: "flex",

                  alignItems: "center",

                  justifyContent: "center",

                  width: 32,

                  height: 32,

                  transition: "all 0.3s ease",

                  zIndex: 20,

                  "&:hover": {

                    transform: "scale(1.1)",

                  },

                }}

              >

                <svg

                  width="20"

                  height="20"

                  viewBox="0 0 16 16"

                  fill="none"

                  xmlns="http://www.w3.org/2000/svg"

                  style={{

                    transform: isProfilesExpanded

                      ? "rotate(180deg)"

                      : "rotate(0deg)",

                    transition: "transform 0.3s ease",

                  }}

                >

                  <path

                    d="M4 6L8 10L12 6"

                    stroke="#666"

                    strokeWidth="2"

                    strokeLinecap="round"

                    strokeLinejoin="round"

                  />

                </svg>

              </Box>



              {/* Contenido de la tarjeta */}

              {loading ? (

                <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>

                  <CircularProgress />

                </Box>

              ) : (

                <Box

                  sx={{

                    transition: "all 0.4s ease-in-out",

                    opacity: isProfilesExpanded ? 1 : 0.9,

                    transform: isProfilesExpanded

                      ? "translateY(0)"

                      : "translateY(-10px)",

                    pr: 8,

                  }}

                >

                  {metricsLegendData.length === 0 ? (

                    <Box

                      sx={{

                        py: 4,

                        textAlign: "center",

                        color: "#666",

                      }}

                    >

                      <Typography

                        variant="h6"

                        sx={{

                          mb: 2,

                          fontWeight: "bold",

                          fontSize: "18px",

                          color: "#333",

                        }}

                      >

                        {t("widgetStatistics.accessibilityProfiles")}

                      </Typography>

                      <Typography variant="body2">

                        {t("widgetStatistics.noDataAvailable")}

                      </Typography>

                    </Box>

                  ) : isProfilesExpanded ? (

                    // Vista expandida (sin cambios)

                    <Box>

                      <Typography

                        variant="h6"

                        sx={{ mb: 3, fontWeight: "bold", fontSize: "18px" }}

                      >

                        {t("widgetStatistics.accessibilityProfiles")}

                      </Typography>

                      <Grid container spacing={3} alignItems="stretch">

                        {/* Gráfica de área a la izquierda */}

                        <Grid item xs={12} md={8}>

                          <Box sx={{ height: "100%", minHeight: 500 }}>

                            <ResponsiveContainer width="100%" height="100%">

                              <AreaChart

                                data={metricsChartData}

                                margin={{

                                  top: window.innerWidth < 600 ? 10 : 20,

                                  right: window.innerWidth < 600 ? 5 : 30,

                                  left: window.innerWidth < 600 ? -10 : 20,

                                  bottom: 0,

                                }}

                              >

                                <defs>

                                  <linearGradient

                                    id="colorProfiles"

                                    x1="0"

                                    y1="0"

                                    x2="0"

                                    y2="1"

                                  >

                                    <stop

                                      offset="5%"

                                      stopColor="#0F52BD"

                                      stopOpacity={0.4}

                                    />

                                    <stop

                                      offset="95%"

                                      stopColor="#0F52BD"

                                      stopOpacity={0}

                                    />

                                  </linearGradient>

                                </defs>

                                <CartesianGrid

                                  strokeDasharray="3 3"

                                  stroke="#E0E0E0"

                                />

                                <XAxis

                                  dataKey="name"

                                  tick={{ fontSize: window.innerWidth < 600 ? 8 : 11 }}

                                  stroke="#666"

                                  angle={window.innerWidth < 600 ? -45 : 0}

                                  textAnchor={window.innerWidth < 600 ? "end" : "middle"}

                                  height={window.innerWidth < 600 ? 60 : 30}

                                />

                                <YAxis

                                  tick={{ fontSize: window.innerWidth < 600 ? 9 : 12 }}

                                  stroke="#666"

                                  domain={[0, "dataMax + 10%"]}

                                  allowDataOverflow={false}

                                  type="number"

                                  tickCount={window.innerWidth < 600 ? 5 : 8}

                                />

                                <Tooltip content={<ProfilesTooltip />} />

                                <Area

                                  type="monotone"

                                  dataKey="value"

                                  stroke="#0F52BD"

                                  strokeWidth={2}

                                  fillOpacity={1}

                                  fill="url(#colorProfiles)"

                                  connectNulls={false}

                                  dot={false}

                                  activeDot={{ r: 4, fill: "#0F52BD" }}

                                />

                              </AreaChart>

                            </ResponsiveContainer>

                          </Box>

                        </Grid>



                        {/* Panel derecho con tarjetas */}

                        <Grid item xs={12} md={4}>

                          <Box

                            sx={{

                              display: "flex",

                              flexDirection: "column",

                              gap: 3,

                              height: "100%",

                              minHeight: 500,

                            }}

                          >

                            {/* Subtarjeta con total de perfiles */}

                            <Paper

                              sx={{

                                p: 3,

                                textAlign: "center",

                                boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",

                                borderRadius: 2,

                              }}

                            >

                              <AccessibilityIcon

                                sx={{ fontSize: 40, color: "#0F52BD", mb: 1 }}

                              />

                              <Typography

                                variant="h4"

                                sx={{

                                  fontSize: "32px",

                                  fontWeight: "bold",

                                  color: "#0F52BD",

                                  mb: 1,

                                }}

                              >

                                {totalProfilesUsed.toLocaleString()}

                              </Typography>

                              <Typography

                                variant="body2"

                                sx={{ color: "#666" }}

                              >

                                {t("widgetStatistics.totalProfilesUsed")}

                              </Typography>

                            </Paper>



                            {/* Subtarjeta con leyenda */}

                            <Paper

                              sx={{

                                p: 2,

                                boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",

                                borderRadius: 2,

                                flex: 1,

                                overflow: "auto",

                              }}

                            >

                              <Typography

                                variant="subtitle1"

                                sx={{

                                  fontWeight: "bold",

                                  mb: 2,

                                  fontSize: "16px",

                                }}

                              >

                                {t("widgetStatistics.profilesLegend")}

                              </Typography>

                              <List dense>

                                {metricsLegendData.map((item, index) => (

                                  <ListItem key={index} sx={{ py: 0.5 }}>

                                    <Box

                                      sx={{

                                        width: 12,

                                        height: 12,

                                        backgroundColor:

                                          index === 0 ? "#0F52BD" : "#C7D7F0",

                                        borderRadius: "50%",

                                        mr: 1,

                                        flexShrink: 0,

                                      }}

                                    />

                                    <ListItemText

                                      primary={

                                        <Box

                                          sx={{

                                            display: "flex",

                                            justifyContent: "space-between",

                                            alignItems: "center",

                                          }}

                                        >

                                          <Typography

                                            variant="body2"

                                            sx={{ fontSize: "12px" }}

                                          >

                                            {item.name}

                                          </Typography>

                                          <Chip

                                            label={item.value}

                                            size="small"

                                            sx={{

                                              height: 20,

                                              fontSize: "10px",

                                              backgroundColor:

                                                index === 0

                                                  ? "#0F52BD"

                                                  : "#E0E0E0",

                                              color:

                                                index === 0 ? "white" : "#666",

                                            }}

                                          />

                                        </Box>

                                      }

                                    />

                                  </ListItem>

                                ))}

                              </List>

                            </Paper>

                          </Box>

                        </Grid>

                      </Grid>

                    </Box>

                  ) : (

                    // Vista colapsada (horizontal)

                    <Box

                      sx={{

                        display: "flex",

                        alignItems: "center",

                        justifyContent: "space-between",

                        height: { xs: "auto", md: "80px" }, // CAMBIAR: altura automática en móvil

                        width: "100%",

                        flexDirection: { xs: "column", md: "row" }, // CAMBIAR: stack vertical en móvil

                        gap: { xs: 2, md: 0 }, // CAMBIAR: gap en móvil

                        py: { xs: 2, md: 0 }, // CAMBIAR: padding vertical en móvil

                        animation: !isProfilesExpanded

                          ? "fadeInCollapse 0.4s ease-in-out"

                          : "none",

                        "@keyframes fadeInCollapse": {

                          "0%": {

                            opacity: 0,

                            transform: "translateY(20px)",

                          },

                          "100%": {

                            opacity: 1,

                            transform: "translateY(0)",

                          },

                        },

                      }}

                    >

                      {/* Título y subtítulo */}

                      <Box

                        sx={{

                          width: { xs: "100%", md: "300px" }, // CAMBIAR: full width en móvil

                          minWidth: { xs: "100%", md: "300px" }, // CAMBIAR: responsive min width

                          maxWidth: { xs: "100%", md: "300px" }, // CAMBIAR: responsive max width

                          pr: { xs: 0, md: 2 }, // CAMBIAR: sin padding right en móvil

                          textAlign: { xs: "center", md: "left" }, // CAMBIAR: centrado en móvil

                          order: { xs: 1, md: 0 },

                        }}

                      >

                        <Typography

                          variant="h6"

                          sx={{

                            fontWeight: "bold",

                            fontSize: { xs: "20px", md: "24px" }, // CAMBIAR: más pequeño en móvil

                            mb: { xs: 0.5, md: 2 }, // CAMBIAR: menos margin en móvil

                            lineHeight: 1.2,

                          }}

                        >

                          {t("widgetStatistics.accessibilityProfiles")}

                        </Typography>

                        <Typography

                          variant="body2"

                          sx={{

                            color: "#666",

                            fontSize: { xs: "12px", md: "14px" }, // CAMBIAR: más pequeño en móvil

                            lineHeight: 1.3,

                            display: { xs: "none", sm: "block" }, // CAMBIAR: ocultar en móvil muy pequeño

                          }}

                        >

                          {t("widgetStatistics.activationsInsideWidget")}

                        </Typography>

                      </Box>



                      {/* Número total de activaciones */}

                      <Box

                        sx={{

                          width: { xs: "100%", md: "240px" }, // CAMBIAR: full width en móvil

                          minWidth: { xs: "100%", md: "240px" }, // CAMBIAR: responsive min width

                          maxWidth: { xs: "100%", md: "240px" }, // CAMBIAR: responsive max width

                          display: "flex",

                          alignItems: "baseline",

                          gap: { xs: 1, md: 1.5 }, // CAMBIAR: menos gap en móvil

                          justifyContent: "center",

                          order: { xs: 2, md: 0 }, // CAMBIAR: último en móvil

                        }}

                      >

                        <Typography

                          variant="h4"

                          sx={{

                            fontSize: { xs: "24px", md: "32px" }, // CAMBIAR: más pequeño en móvil

                            fontWeight: "bold",

                            color: "#000",

                            lineHeight: 1,

                          }}

                        >

                          {totalProfilesUsed.toLocaleString()}

                        </Typography>

                        <Typography

                          variant="body1"

                          sx={{

                            color: "#666",

                            fontSize: { xs: "14px", md: "16px" }, // CAMBIAR: más pequeño en móvil

                            fontWeight: "medium",

                          }}

                        >

                          {t("widgetStatistics.activations")}

                        </Typography>

                      </Box>



                      {/* Perfil más utilizado */}

                      {metricsLegendData.length > 0 && (

                        <Box

                          sx={{

                            width: { xs: "100%", md: "220px" }, // CAMBIAR: full width en móvil

                            minWidth: { xs: "100%", md: "220px" }, // CAMBIAR: responsive min width

                            maxWidth: { xs: "100%", md: "220px" }, // CAMBIAR: responsive max width

                            display: "flex",

                            justifyContent: { xs: "center", md: "flex-end" }, // CAMBIAR: centrar en móvil

                            order: { xs: 3, md: 0 }, // CAMBIAR: segundo en móvil

                          }}

                        >

                          <Paper

                            sx={{

                              p: { xs: 1.5, md: 2 }, // CAMBIAR: menos padding en móvil

                              width: { xs: "100%", md: "180px" }, // CAMBIAR: full width en móvil

                              minWidth: { xs: "100%", md: "180px" }, // CAMBIAR: responsive min width

                              maxWidth: { xs: "100%", md: "180px" }, // CAMBIAR: responsive max width

                              boxShadow:

                                "0px 4px 10px 0px rgba(15, 82, 189, 0.46)",

                              borderRadius: 2,

                              position: "relative",

                              display: "flex",

                              alignItems: "center",

                              justifyContent: "center",

                            }}

                          >

                            {/* Indicador #1 */}

                            <Box

                              sx={{

                                position: "absolute",

                                top: { xs: -6, md: -8 }, // CAMBIAR: ajustar posición en móvil

                                right: { xs: 6, md: 8 }, // CAMBIAR: ajustar posición en móvil

                                width: { xs: 20, md: 24 }, // CAMBIAR: más pequeño en móvil

                                height: { xs: 20, md: 24 }, // CAMBIAR: más pequeño en móvil

                                borderRadius: "4px",

                                backgroundColor: "#0F52BD",

                                color: "white",

                                display: "flex",

                                alignItems: "center",

                                justifyContent: "center",

                                fontSize: { xs: "10px", md: "12px" }, // CAMBIAR: más pequeño en móvil

                                fontWeight: "bold",

                                zIndex: 1,

                              }}

                            >

                              #1

                            </Box>



                            {/* Texto centrado */}

                            <Box

                              sx={{

                                textAlign: "center",

                                px: { xs: 0.5, md: 1 }, // CAMBIAR: menos padding en móvil

                                width: "100%", // CAMBIAR: asegurar que ocupe todo el ancho

                                overflow: "hidden", // CAMBIAR: prevenir overflow

                              }}

                            >

                              <Typography

                                variant="body2"

                                sx={{

                                  fontSize: { xs: "14px", md: "16px" }, // CAMBIAR: más pequeño en móvil

                                  fontWeight: "bold",

                                  lineHeight: 1.2,

                                  color: "#333",

                                  wordBreak: "break-word",

                                  whiteSpace: "normal",

                                  hyphens: "auto",

                                  overflow: "hidden", // CAMBIAR: prevenir overflow

                                  textOverflow: "ellipsis", // CAMBIAR: truncar si es necesario

                                  display: "-webkit-box", // CAMBIAR: para multiline truncation

                                  WebkitLineClamp: { xs: 2, md: 3 }, // CAMBIAR: limitar líneas

                                  WebkitBoxOrient: "vertical", // CAMBIAR: orientación vertical

                                }}

                              >

                                {metricsLegendData[0].name}

                              </Typography>

                            </Box>

                          </Paper>

                        </Box>

                      )}

                    </Box>

                  )}

                </Box>

              )}

            </Card>



            {/* AGREGAR LAS NUEVAS 3 TARJETAS AQUÍ */}



            {/* Tarjeta de Herramientas de Navegación */}

            <AccessibilityToolCard

              title={t("widgetStatistics.navigationTools")}

              data={navigationData}

              loading={loadingNavigation}

              isExpanded={isNavigationExpanded}

              onToggle={handleToggleNavigation}

              cardRef={navigationCardRef}

              iconColor="#0F52BD"

            />



            {/* Tarjeta de Herramientas de Color */}

            <AccessibilityToolCard

              title={t("widgetStatistics.colorTools")}

              data={colorData}

              loading={loadingColor}

              isExpanded={isColorExpanded}

              onToggle={handleToggleColor}

              cardRef={colorCardRef}

              iconColor="#0F52BD"

            />



            {/* Tarjeta de Herramientas de Contenido */}

            <AccessibilityToolCard

              title={t("widgetStatistics.contentTools")}

              data={contentData}

              loading={loadingContent}

              isExpanded={isContentExpanded}

              onToggle={handleToggleContent}

              cardRef={contentCardRef}

              iconColor="#0F52BD"

            />

          </Box>

        </Container>

      </Box>

      </Box>

    </Box>



      {/* AGREGAR Modal de Guías de Implementación */}

      <Dialog

        open={guidesModalOpen}

        onClose={handleCloseGuides}

        fullWidth

        maxWidth="lg"

        PaperProps={{

          sx: {

            borderRadius: 3,

            p: 0,

            m: 0,

            overflow: "hidden",

            "& .MuiDialogContent-root": {

              padding: 0,

              margin: 0,

            },

          },

        }}

      >

        <DialogContent

          sx={{

            padding: 0,

            margin: 0,

            "&:first-of-type": {

              paddingTop: 0,

            },

          }}

        >

          <PlataformaSelector onClose={handleCloseGuides} />

        </DialogContent>

      </Dialog>

    </>

  );

};



export default WidgetStatistics;
